// Import

// Libraries
import styled from 'styled-components';

export const SlideItem = styled.div`
  width: 100%;
  justify-content: center;
  img {
    width: 100%;
  }
`;

export const Slider = styled.div`
  display: 'flex';
  flex-direction: 'column';
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export const SliderContainer = styled.div`
  width: 100%;
  margin: 1em 0em 1em 0em;
  overflow: hidden;
`;
